import { State } from 'src/redux/reducer';
import { isLoaded, isPending, isRejected, shouldLoad } from 'src/redux/utils';

export const changeStatusSurveyStatusSelector = (state: State) =>
  state.changeSurveyStatus.status;
export const changeStatusSurveySelector = (state: State) =>
  state.changeSurveyStatus.entities;
export const changeStatusSurveyLoadedSelector = isLoaded(
  changeStatusSurveyStatusSelector,
);
export const shouldLoadedDuplicateSurveysSelector = shouldLoad(
  changeStatusSurveyStatusSelector,
);
export const changeStatusSurveyRejectedSelector = isRejected(
  changeStatusSurveyStatusSelector,
);
export const changeStatusSurveyPendingSelector = isPending(
  changeStatusSurveyStatusSelector,
);
